import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {Breadcrumbs, Text} from '@forecast-it/design-system';

interface Props {
	slug: string;
}

// The design system's breadcrumb items inherit their type; only the link colour
// is ours, so "All tickets" reads as the way back and the slug as where you are.
const CrumbLink = styled(Link)`
	color: ${p => p.theme.sys.color.text.content.primary};
	text-decoration: none;
	&:hover {
		text-decoration: underline;
	}
`;

export function TicketBreadcrumb({slug}: Props) {
	return (
		<Breadcrumbs>
			<Breadcrumbs.Item>
				<CrumbLink to="/tickets">All tickets</CrumbLink>
			</Breadcrumbs.Item>
			<Breadcrumbs.Item>
				<Text>{slug}</Text>
			</Breadcrumbs.Item>
		</Breadcrumbs>
	);
}
